import React, { useEffect, useState } from 'react'
import { Card, Button } from 'react-bootstrap'
import { FormCustom, Input } from '../../../components/form'
import { doRequestPost } from '../../../api'
import { doToast, appUrl } from '../../../utils'
import { toast } from 'react-toastify'
import { useHistory, useLocation } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import LoadingIcon from '../../../components/loading/LoadingIcon'
import { setJwt } from '../../../context/slices/session/sessionSlice'

const GoogleButtonAuth = () => {
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()
  const location = useLocation()

  useEffect(() => {
    if (!window.google?.accounts?.id) return;

    window.google.accounts.id.initialize({
      client_id: '868212308646-hsdok1qh5ej01ubsv88jlasbb0tlvqr3.apps.googleusercontent.com',
      callback: async (response) => {
        console.log("Google response:", response);
        try {
          setLoading(true)
          const responseGoogle = await doRequestPost({
            url: '/customer/auth/google',
            data: {
              credential: response.credential,
              p_old_key_customer: localStorage.getItem('session-customer-storage') || null
            }
          })

          doToast({
            response: responseGoogle.response,
            message: responseGoogle.message,
            toast
          })

          if (responseGoogle.response === 'success') {
            localStorage.clear()
            const redirectRaw = new URLSearchParams(location.search).get('redirect')
            const nextUrl = redirectRaw ? decodeURIComponent(redirectRaw) : appUrl({ url: '/cuenta/login' })

            const usersLogin = await doRequestPost({
              url: '/auth/login',
              data: {
                p_username: responseGoogle.data.username,
                p_password: responseGoogle.data.google_id,
              }
            })
            if (usersLogin.response === 'success') {
              const { jwt } = usersLogin.data
              dispatch(setJwt({ jwt }))

              const getSession = await doRequestPost({
                url: '/auth/session',
              })
              if (getSession.response === 'success') {
                const { key_customer } = getSession.data
                localStorage.setItem('session-customer-storage', key_customer)
                window.location.href = nextUrl
              }
            }
          }
        } catch (error) {
          doToast({
            response: 'error',
            message: error.message || 'Ocurrió un error',
            toast
          })
        } finally {
          setLoading(false)
        }
      }
    });

    window.google.accounts.id.renderButton(
      document.getElementById("gbtn"),
      { theme: "outline", size: "large", width: "100%" }
    );
  }, [location, dispatch]);

  return (
    <>
      {loading && <LoadingIcon />}
      <div id="gbtn" className="mt-2 d-flex justify-content-center" />
    </>
  )
}

export default function CustomerAuthForm({ mode = 'login' }) {
  const history = useHistory()
  const location = useLocation()
  const dispatch = useDispatch()
  const isRegister = mode === 'register'
  const [form, setForm] = useState({
    name_customer: '',
    last_name_customer: '',
    email_customer: '',
    phone_customer: '',
    password: '',
    confirm_password: ''
  })
  const [showPwd, setShowPwd] = useState(false)
  const [showConfirmPwd, setShowConfirmPwd] = useState(false)

  const rules = {
    minLength: form.password.length >= 8,
    hasUpper: /[A-Z]/.test(form.password),
    hasNumber: /\d/.test(form.password),
  }

  const [doSubmit, setDoSubmit] = useState(false)

  const onSubmit = async () => {
    try {
      const redirectRaw = new URLSearchParams(location.search).get('redirect')
      const nextUrl = redirectRaw ? decodeURIComponent(redirectRaw) : appUrl({ url: '/mis-tickets' })
      if (isRegister) {
        // Validaciones frontend
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        if (!emailRegex.test(form.email_customer)) {
          doToast({ response: 'warning', message: 'Ingrese un correo válido.', toast })
          return
        }
        if (!(rules.minLength && rules.hasUpper && rules.hasNumber)) {
          doToast({ response: 'warning', message: 'La contraseña no cumple los requisitos.', toast })
          return
        }
        if (form.password !== form.confirm_password) {
          doToast({ response: 'warning', message: 'Las contraseñas no coinciden.', toast })
          return
        }
        setDoSubmit(true)
        const resp = await doRequestPost({
          url: '/customer/auth/register',
          data: {
            p_name_customer: form.name_customer,
            p_last_name_customer: form.last_name_customer,
            p_email_customer: form.email_customer,
            p_phone_customer: form.phone_customer,
            p_password: form.password,
            // Reutilizamos el key si ya existe anónimo
            p_id_customers: localStorage.getItem('session-customer-storage') || null
          }
        })
        if (resp.response === 'success') {
          localStorage.clear()

          const usersLogin = await doRequestPost({
            url: '/auth/login',
            data: {
              p_username: form.email_customer,
              p_password: form.password,
            }
          })
          if (usersLogin.response === 'success') {
            const { jwt } = usersLogin.data
            dispatch(setJwt({ jwt }))

            const getSession = await doRequestPost({
              url: '/auth/session',
            })
            if (getSession.response === 'success') {
              const { key_customer } = getSession.data
              localStorage.setItem('session-customer-storage', key_customer)
              window.location.href = nextUrl
            }
          }
        } else {
          doToast({ response: 'warning', message: resp.message || 'No se pudo registrar', toast })
        }
      } else {
        // Login normal usando /auth/login
        const oldKey = localStorage.getItem('session-customer-storage')
        console.log('oldKey', oldKey)
        setDoSubmit(true)

        const usersLogin = await doRequestPost({
          url: '/auth/login',
          data: {
            p_username: form.email_customer,
            p_password: form.password,
            p_old_key_customer: oldKey
          }
        })
        if (usersLogin.response === 'success') {
          const { jwt } = usersLogin.data
          dispatch(setJwt({ jwt }))

          const getSession = await doRequestPost({
            url: '/auth/session',
          })
          if (getSession.response === 'success') {
            const { jwt, key_customer } = getSession.data
            dispatch(setJwt({ jwt }))
            localStorage.setItem('session-customer-storage', key_customer)
          }
          window.location.href = nextUrl
        } else {
          doToast({ response: 'warning', message: usersLogin.message || 'No se pudo iniciar sesión', toast })
        }
      }
    } catch (error) {
      doToast({ response: 'error', message: 'Ocurrió un error', toast })
    }
    finally {
      setDoSubmit(false)
    }
  }

  return <>
    <div className="row justify-content-center">
      <div className="col-xl-5 col-lg-6 col-md-8 col-12">
        <Card className="mt-3 shadow-sm">
          <Card.Body className="p-4 pt-5 pb-4">
            <h5 className="mb-3 text-center">{isRegister ? 'Crear cuenta' : 'Acceder a mi cuenta'}</h5>
            <FormCustom onSubmit={onSubmit} viewSubmit={false}>
              {isRegister && <>
                <Input
                  classNameParent="col-12 mb-2"
                  text="Nombres"
                  value={form.name_customer}
                  onChange={e => setForm({ ...form, name_customer: e.target.value })}
                  required
                  maxLength={100}
                />
                <Input
                  classNameParent="col-12 mb-2"
                  text="Apellidos"
                  value={form.last_name_customer}
                  onChange={e => setForm({ ...form, last_name_customer: e.target.value })}
                  required
                  maxLength={100}
                />
                <Input
                  classNameParent="col-12 mb-2"
                  text="Teléfono"
                  value={form.phone_customer}
                  onChange={e => setForm({ ...form, phone_customer: e.target.value })}
                  required
                  maxLength={20}
                />
              </>}

              <Input
                classNameParent="col-12 mb-2"
                text="Email"
                type="email"
                value={form.email_customer}
                onChange={e => setForm({ ...form, email_customer: e.target.value })}
                required
                maxLength={100}
                placeholder="Email"
              />
              <Input
                classNameParent="col-12 mb-3"
                text="Contraseña"
                type={showPwd ? 'text' : 'password'}
                value={form.password}
                onChange={e => setForm({ ...form, password: e.target.value })}
                required
                maxLength={60}
                append={[
                  <Button variant="light" onClick={() => setShowPwd(!showPwd)}>
                    <i className={`fa ${showPwd ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                  </Button>
                ]}
                placeholder="Contraseña"
              />
              {isRegister && <div className="col-12 mb-2">
                <ul className="mb-0" style={{ listStyle: 'none', paddingLeft: 0 }}>
                  <li>
                    <span><i className={`fa me-2 ${rules.minLength ? 'fa-check text-success' : 'fa-times text-muted'}`}></i></span>
                    <span className='text-muted ms-2'>Al menos 8 caracteres</span>
                  </li>
                  <li>
                    <span><i className={`fa me-2 ${rules.hasUpper ? 'fa-check text-success' : 'fa-times text-muted'}`}></i></span>
                    <span className='text-muted ms-2'>Una letra mayúscula</span>
                  </li>
                  <li>
                    <span><i className={`fa me-2 ${rules.hasNumber ? 'fa-check text-success' : 'fa-times text-muted'}`}></i></span>
                    <span className='text-muted ms-2'>Un número</span>
                  </li>
                </ul>
              </div>}

              {isRegister && <Input
                classNameParent="col-12 mb-3"
                text="Confirmar Contraseña"
                type={showConfirmPwd ? 'text' : 'password'}
                value={form.confirm_password}
                onChange={e => setForm({ ...form, confirm_password: e.target.value })}
                required
                maxLength={60}
                append={[
                  <Button variant="light" onClick={() => setShowConfirmPwd(!showConfirmPwd)}>
                    <i className={`fa ${showConfirmPwd ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                  </Button>
                ]}
              />}

              <div className="col-12">
                <Button type="submit" block variant="primary" className='w-100'>
                  {isRegister ? 'Crear cuenta' : 'Iniciar sesión'}
                </Button>
              </div>

              <GoogleButtonAuth />
            </FormCustom>
          </Card.Body>
        </Card>

        <div className="text-center mt-3">
          {isRegister
            ? <Button variant="link" onClick={() => {
              const redirectRaw = new URLSearchParams(location.search).get('redirect')
              const redirectQuery = redirectRaw ? `?redirect=${encodeURIComponent(decodeURIComponent(redirectRaw))}` : ''
              history.push(appUrl({ url: '/cuenta/login' + redirectQuery }))
            }}>
              ¿Ya tienes cuenta? Inicia sesión aquí
            </Button>
            : <Button variant="link" onClick={() => {
              const redirectRaw = new URLSearchParams(location.search).get('redirect')
              const redirectQuery = redirectRaw ? `?redirect=${encodeURIComponent(decodeURIComponent(redirectRaw))}` : ''
              history.push(appUrl({ url: '/cuenta/registro' + redirectQuery }))
            }}>
              ¿No tienes cuenta? Regístrate aquí
            </Button>}
        </div>
      </div>
    </div>
    {doSubmit && <LoadingIcon />}
  </>
}

